<template>
  <div class="py-4 container-fluid">
    <div class="custom-header font-weight-bold text-left">Endorsed Crew List</div>
    <div class="card mb-4">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-md-5 text-left">
                    <label for="crewValue" class="font-weight-bold">Search Crew Name :</label>
                    <div class="input-group">

                      <div class="input-group-prepend">
                        <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                          <i class="fa fa-search pr-2"></i>By : {{ key }}
                        </button>

                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" @click="setKey('all')" :class="{'active':endorseMentParams.searchKey == 'all'}">All</a>
                          <a class="dropdown-item" href="#" @click="setKey('last_name')" :class="{'active':endorseMentParams.searchKey == 'last_name'}">LastName</a>
                          <a class="dropdown-item" href="#" @click="setKey('first_name')" :class="{'active':endorseMentParams.searchKey == 'first_name'}">FirstName</a>
                          <a class="dropdown-item" href="#" @click="setKey('middle_name')" :class="{'active':endorseMentParams.searchKey == 'middle_name'}">MiddleName</a>
                          <a class="dropdown-item" href="#" @click="setKey('rank')" :class="{'active':endorseMentParams.searchKey == 'rank'}">Rank</a>
                          <a class="dropdown-item" href="#" @click="setKey('crewipn')" :class="{'active':endorseMentParams.searchKey == 'crewipn'}">CrewIPN</a>
                          <!--  <a class="dropdown-item" href="#" @click="setKey('rank')" :class="{'active':searchKey == 'rank'}">Rank</a>  -->
                        </div>
                      </div>

                      <input type="text"
                             id="crewValue"
                             class="form-control form-control-sm"
                             v-model="endorseMentParams.searchValue"
                             v-on:input="searchCrew(1)"
                             :placeholder="keyPlaceHolder"
                             aria-label="Text input with dropdown button">
                    </div>
                  </div>

                  <div class="col-md-2 text-left">
                    <label for="building" class="font-weight-bold">Building :</label>
                    <select id="building" class="custom-select custom-select-sm" v-model="endorseMentParams.building" v-on:change="setBuilding">
                      <option :value="''">All</option>
                      <option v-for="hotel in hotelKeys" :key="hotel.id" :value="hotel.id" :selected="hotel == endorseMentParams.building">
                        {{ hotel.name.toUpperCase() }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-2 text-left">
                    <label for="status" class="font-weight-bold">Status :</label>
                    <select id="status" class=" custom-select custom-select-sm" v-on:change="setStatus">
                      <option :value="''">All</option>
                      <option v-for="(status,index) in reservationStatus" :key="index" :value="index+1">
                        {{ status[index] }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-2 text-left ">
                    <label for="displayCounts" class="font-weight-bold">Records:</label>
                    <select class="custom-select custom-select-sm" id="displayCounts" v-model="endorseMentParams.count" v-on:change="setRecords">
                      <option v-for="count in displayCounts" :key="count" :value="count" :selected="count === endorseMentParams.count">
                        {{ count }} records
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row pt-4">
                  <div class="col-md-3 text-left">
                    <label for="batchNo" class="font-weight-bold">Batch No :</label>
                    <multiSelect v-model="value" :options="batchKeyDetails" :custom-label="batchNoDtls"
                                 placeholder="Search Batch no."
                                 :select-label="'Select'"
                                 label="Batch No"
                                 track-by="id"
                                 :optionsLimi="1000"
                                 id="batchNo"
                                 @input="batchSearch"
                                 class="p-0 form-control-sm">
                    </multiSelect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body fs-13px">
        <div class="text-left">
          <small> {{ `${endorsePagination.from} - ${endorsePagination.to} of ${endorsePagination.total}` }}</small>
        </div>

        <nav aria-label="..." class="pt-0">
          <ul class="pagination pagination-sm">
            <li class="page-item" :class="{ 'disabled': endorsePagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">
                <font-awesome-icon icon="step-backward"/>
                First
              </button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === endorsePagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': endorsePagination.currentPage === endorsePagination.lastPage}">
              <button class="page-link" @click="setPage(endorsePagination.lastPage)">
                Last
                <font-awesome-icon icon="step-forward"/>
              </button>
            </li>
          </ul>
        </nav>

        <div class="table-responsive-lg">
          <table class="table table-bordered" width="100%" cellspacing="0">
            <thead>
            <tr class="bg-light">
              <th scope="col" class="p-1 text-center">
                <button id="reset" class="btn btn-sm tnkc-secondary" @click="reset" data-toggle="tooltip" data-placement="top" data-html="true" title="Click to Refresh Data Table">
                  <font-awesome-icon icon="undo"/>
                </button>
              </th>
            </tr>
            <tr class="bg-light">
              <th scope="col" class="p-1 text-center">#</th>
              <th scope="col" class="p-1 text-center">
                <button class="btn btn-xsm" @click="sortByBatch('batch_no',sorting)">
                  <span class="font-weight-bold"> Batch-No</span>
                  <sup class="ml-1" v-if="sList.sortBatch == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortBatch" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortBatch" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm" @click="sortByRank('rank',sorting)">
                  <span class="font-weight-bold">Rank</span>
                  <sup class="ml-1" v-if="sList.sortRank == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortRank" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortRank" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm" @click="sortByName('crew',sorting)">
                  <span class="font-weight-bold">Crew Name</span>
                  <sup class="ml-1" v-if="sList.sortName == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortName" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortName" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm" @click="sortByRoom('room',sorting)">
                  <span class="font-weight-bold">Room</span>
                  <sup class="ml-1" v-if="sList.sortRoom == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortRoom" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortRoom" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm">
                  <span class="font-weight-bold">Building</span>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm" @click="sortByCheckIn('check_in',sorting)">
                  <span class="font-weight-bold">Check In</span>
                  <sup class="ml-1" v-if="sList.sortCheckIn == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortCheckIn" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortCheckIn" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm " @click="sortByCheckOut('check_out',sorting)">
                  <span class="font-weight-bold">Check Out</span>
                  <sup class="ml-1" v-if="sList.sortCheckOut == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortCheckOut" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortCheckOut" icon="caret-down"/>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm font-weight-bold" @click="sortByDays('days_stayed',sorting)">
                  <span class="font-weight-bold">#-Day</span>
                  <sup class="ml-1" v-if="sList.sortDays == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortDays" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortDays" icon="caret-down"/>
                </button>
              </th>

              <!-- todo optional -->
              <!--<th scope="col" class="p-1">Estimate Cost</th>-->

              <th scope="col" class="p-1">
                <button class="btn btn-xsm font-weight-bold">
                  <span>Status</span>
                </button>
              </th>
              <th scope="col" class="p-1">
                <button class="btn btn-xsm " @click="sortRemarksCount('remarks_count',sorting)">
                  <span class="font-weight-bold">Remarks</span>
                  <sup class="ml-1" v-if="sList.sortRemarksCount == null">
                    <font-awesome-icon icon="caret-up"/>
                    <font-awesome-icon icon="caret-down"/>
                  </sup>
                  <font-awesome-icon class="ml-1" v-else-if="sList.sortRemarksCount" icon="caret-up"/>
                  <font-awesome-icon class="ml-1" v-else-if="!sList.sortRemarksCount" icon="caret-down"/>
                </button>
              </th>

              <th scope="col" class="p-1 vert-aligned">
                <span>Actions</span>
              </th>

              <th scope="col" class="p-1" v-if="isCrewOfficer || isSystemAdmin || isOpsOfficer || isDocSupervisor">
                <input type="checkbox" id="select-all" class="mr-2" v-model="allSelected" @click="selectAll"/>
                <label for="select-all" class="mt-1 mr-2">All</label>
                <button class="btn btn-xsm tnkc-success" data-toggle="modal" data-target="#actionRemarks" data-backdrop="static" data-keyboard="false" @click="setActionType(null,1)">
                  Approved
                </button>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(crewEndorse,index) in crewEndorseList" :key="crewEndorse.crew_reservation_id">
              <th scope="row" class="p-1 align-middle">{{ index + 1 }}</th>
              <th class="p-1 align-middle">
                <small>{{ crewEndorse.batch_no }}</small>
              </th>
              <td class="p-1 align-middle ">{{ crewEndorse.rank ? crewEndorse.rank.toUpperCase() : '' }}
              </td>
              <td class="p-1 align-middle text-left sm">
                <button class="btn btn-xsm" @click="viewProfile(crewEndorse.crew_id)" title="Click to view profile">
                  <u>{{ crewEndorse.crew }}</u>
                </button>
              <td class="p-1 align-middle">{{ crewEndorse.room ? crewEndorse.room : '--' }}</td>
              <td class="p-1 align-middle">
                <small>{{ crewEndorse.building ? crewEndorse.building.toUpperCase() : '--' }}</small>
              </td>
              <td class="p-1 align-middle justify-content-center">
                <sup v-if="crewEndorse.building">
                  <font-awesome-icon icon="bookmark"/>
                </sup>
                <small>{{ crewEndorse.check_in | moment('D MMM YYYY') }}</small>
              </td>
              <td class="p-1 align-middle">
                <sup v-if="crewEndorse.building">
                  <font-awesome-icon icon="bookmark"/>
                </sup>
                <sup v-if="crewEndorse.extend_date" class="ml-1">
                  <font-awesome-icon icon="arrows-alt-h"/>
                </sup>
                <small> {{ crewEndorse.check_out | moment('D MMM YYYY') }}</small>
              </td>
              <td class="p-1">{{ crewEndorse.days_stayed ? crewEndorse.days_stayed : '--' }}</td>
              <!--<td class="p-1 align-middle"> 3500 </td>-->
              <td class="p-1 align-middle" v-bind:class="bookedExpired(crewEndorse)">{{ crewEndorse.status }}</td>
              <td class="p-1 align-middle">
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-sm btn-light" data-toggle="modal" data-target="#remarksModal" data-backdrop="static" data-keyboard="false" @click="endorsed_remarks(crewEndorse.crew_reservation_id)">
                  <font-awesome-icon icon="comments"/>
                  <sup class="ml-2">{{ crewEndorse.remarks_count }}</sup>
                </button>
              </td>
              <td class="p-1 vert-aligned">
                <!--<button class="btn btn-xsm tnkc-primary" @click="viewProfile(crewEndorse.crew_id)">
                  <font-awesome-icon icon="eye"/>
                  <small>View</small>
                </button>-->

                <button class="btn btn-xsm tnkc-primary" v-if="!crewEndorse.building || crewEndorse.is_active" v-on:click="crew_endorse_details(crewEndorse.crew_reservation_id)" data-toggle="modal" data-target="#editEndorsement" data-backdrop="static" data-keyboard="false">
                  <font-awesome-icon icon="eye"/>
                  <small class="ml-1">View</small>
                </button>

                <button class="btn btn-xsm tnkc-success ml-1"
                        v-if="crewEndorse.building && crewEndorse.is_active && crewEndorse.is_extend && (isCrewOfficer || isSystemAdmin || isDocSupervisor|| isOpsOfficer)"
                        :disabled="crewEndorse.is_extend">
                  <font-awesome-icon icon="arrows-alt-h"/>
                  <small class="font-weight-bold ml-1">Rqstd</small>
                </button>

                <button class="btn btn-xsm tnkc-warning ml-1"
                        v-if="crewEndorse.building && crewEndorse.is_active && !crewEndorse.is_extend && !crewEndorse.is_checkOut && (isCrewOfficer || isSystemAdmin || isDocSupervisor|| isOpsOfficer)"
                        data-toggle="modal"
                        data-target="#actionRemarks"
                        data-backdrop="static"
                        data-keyboard="false"
                        @click="setActionType({id : crewEndorse.crew_reservation_id, booked_id: crewEndorse.booked_id},3)">
                  <font-awesome-icon icon="arrows-alt-h"/>
                  <small class="font-weight-bold ml-1">Extend</small>
                </button>

                <button class="btn btn-xsm tnkc-secondary ml-1" v-if="!crewEndorse.building && crewEndorse.is_active && (isCrewOfficer || isSystemAdmin || isDocSupervisor|| isOpsOfficer)" data-toggle="modal" data-target="#actionRemarks" data-backdrop="static" data-keyboard="false" @click="setActionType(crewEndorse,2)">
                  <font-awesome-icon icon="times"/>
                  <small class="ml-1">Cancel</small>
                </button>

                <button class="btn btn-xsm tnkc-danger ml-1" v-if="!crewEndorse.is_active && (isCrewOfficer || isSystemAdmin || isDocSupervisor|| isOpsOfficer)" @click="delete_crew_endorse(crewEndorse.crew_reservation_id)">
                  <font-awesome-icon icon="times"/>
                  <small class="ml-1">Remove</small>
                </button>
              </td>

              <td class="p-1 align-middle vert-aligned" v-if="isCrewOfficer || isSystemAdmin || isDocSupervisor|| isOpsOfficer">
                <div>
                  <input type="checkbox" id="approval" v-model="selectedEndorseIds" :value="crewEndorse.crew_reservation_id" @click="select" v-if="crewEndorse.is_active" :disabled="disableCheckbox(crewEndorse)">
                </div>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>


    <!-- remarks -->
    <remarks-modal :search="searchCrew"/>

    <!-- action w/ remarks -->
    <action-remarks
        :actType="actionType"
        :approved="approve_endorsement"
        :cancel="cancel_endorsement"
        :extend="extend_endorsement"/>

    <!-- endorse / details -->
    <endorse-dtls-modal
        :crewEndorse="crewEndorse"
        :newRemarks="newRemarks"
        :updateCrewEndorsementDtls="update_crew_endorsement_dtls"/>

  </div>
</template>

<script>

import {mapGetters, mapActions} from 'vuex';
import MultiSelect from 'vue-multiselect';
import RemarksModal from './_modals/remarksModal';
import EndorseDtls from './_modals/endorseDtlsModal';
import ActionRemarks from './_modals/actionRemarksModal';
import {appMixins} from '../../mixins/app.mixins';
import {GlobalUtility} from '../../service/global-utility.service';
import EndorseDtlsModal from './_modals/endorseDtlsModal';

export default {
  name: 'CrewEndorseList',
  mixins: [appMixins],
  data() {
    return {
      key: '',
      keyPlaceHolder: '',
      displayCounts: [2, 10, 15, 20, 30, 50, 100, 200],

      actionType: 1, //default approve.

      //+1 for index value
      reservationStatus: [
        {0: 'Pending'},
        {1: 'Approved'},
        {2: 'Booked'},
        {3: 'Extended'},
        {4: 'Checked In'},
        {5: 'Checked Out'},
        {6: 'Over-Stay'},
        {7: 'Cancelled'},
      ],

      //for batch
      value: null,
      sorting: false,

      sList: {
        sortBatch: null,
        sortRank: null,
        sortName: null,
        sortRoom: null,
        // sortBuildings: null,
        sortCheckIn: null,
        sortCheckOut: null,
        sortDays: null,
        sortRemarksCount: null,
      },

      selectedEndorseIds: [],
      allSelected: false,

      actionMessage: {
        subject: '',
        remarks: '',
      },

      reservationId: null,
      bookedId: null,

    };
  },

  components: {
    EndorseDtlsModal,
    MultiSelect,
    RemarksModal,
    EndorseDtls,
    ActionRemarks,
    //todo batch modal
  },

  methods: {
    ...mapActions([
      'getCrewEndorseList',
      'getBatchKeyDetails',
      'getCrewEndorseRemarks',
      'getHotelKeyDetails',
      'approvedCrewEndorse',
      'setNullNewRemark',
      'cancelCrewEndorse',
      'getCrewEndorseDetails',
      'updateCrewEndorseDetails',
      'setNullCrewEndorsed',
      'isExtendBooking',
      'setPaginationNull',
      'deleteCrewEndorseMentList',
    ]),

    viewProfile(id) {
      this.$router.push({name: 'CrewProfile', params: {id: id}});
    },

    async searchCrew(initializePage = null) {
      let page = (initializePage) ? initializePage : this.endorsePagination.currentPage;
      this.endorseMentParams.page = page;
      this.endorseMentParams.batch_id = this.value ? this.value.id : '';
      await this.getCrewEndorseList(this.endorseMentParams);
    },

    //key
    setKey(obj) {
      this.endorseMentParams.searchKey = obj;
      this.searchBy();
      this.searchCrew();
      this.resetSList();
    },

    //page
    setPage(page) {
      this.endorsePagination.currentPage = page;
      this.searchCrew();
      this.resetSList();
    },

    setBuilding(e) {
      this.endorseMentParams.building = e.target.value;
      this.searchCrew();
      this.resetSList();
    },

    setStatus(e) {
      this.endorseMentParams.status = e.target.value;
      this.searchCrew(1);
      this.resetSList();
    },

    setRecords(e) {
      this.endorseMentParams.count = parseInt(e.target.value, 10);
      this.searchCrew();
      this.resetSList();
    },

    searchBy() {
      switch (this.endorseMentParams.searchKey) {
        case 'all':
          this.key = 'All';
          this.keyPlaceHolder = 'Search here ...';
          break;

        case 'last_name':
          this.key = 'LastName';
          this.keyPlaceHolder = 'Search Last Name here ...';
          break;

        case 'first_name':
          this.key = 'FirstName';
          this.keyPlaceHolder = 'Search First Name here ...';
          break;

        case 'middle_name':
          this.key = 'MiddleName';
          this.keyPlaceHolder = 'Search Middle Name here ...';
          break;

        case 'crewipn':
          this.key = 'CrewIPN';
          this.keyPlaceHolder = 'Search CrewIPN here ...';
          break;

        case 'rank':
          this.key = 'Rank';
          this.keyPlaceHolder = 'Search CrewRank here ...';
          break;
      }
    },

    sortByData(sortKey, orderBy) {
      const endorseList = this.crewEndorseList;
      this.sorting = !this.sorting;
      endorseList.sort((a, b) => {
        let compare = 0;
        if (orderBy == true) {
          if (a[sortKey] < b[sortKey]) {
            compare = 1;
          } else if (b[sortKey] < a[sortKey]) {
            compare = -1;
          }
          return compare;

        } else if (orderBy == false) {
          if (a[sortKey] > b[sortKey]) {
            compare = 1;
          } else if (b[sortKey] > a[sortKey]) {
            compare = -1;
          }
          return compare;
        }
      });
    },

    sortFlag: function(val) {
      let obj = null;
      if (val == null) {
        obj = true;
      } else if (val == true) {
        obj = false;
      } else if (val == false) {
        obj = true;
      }
      return obj;
    },

    sortByBatch(key, sorting) {
      this.sList.sortBatch = this.sortFlag(this.sList.sortBatch);
      this.sortByData(key, sorting);
    },

    sortByRank(key, sorting) {
      this.sList.sortRank = this.sortFlag(this.sList.sortRank);
      this.sortByData(key, sorting);
    },

    sortByName(key, sorting) {
      this.sList.sortName = this.sortFlag(this.sList.sortName);
      this.sortByData(key, sorting);
    },

    sortByRoom(key, sorting) {
      this.sList.sortRoom = this.sortFlag(this.sList.sortRoom);
      this.sortByData(key, sorting);
    },

    sortByCheckIn(key, sorting) {
      this.sList.sortCheckIn = this.sortFlag(this.sList.sortCheckIn);
      this.sortByData(key, sorting);
    },

    sortByCheckOut(key, sorting) {
      this.sList.sortCheckOut = this.sortFlag(this.sList.sortCheckOut);
      this.sortByData(key, sorting);
    },

    sortByDays(key, sorting) {
      this.sList.sortDays = this.sortFlag(this.sList.sortDays);
      this.sortByData(key, sorting);
    },

    sortRemarksCount(key, sorting) {
      this.sList.sortRemarksCount = this.sortFlag(this.sList.sortRemarksCount);
      this.sortByData(key, sorting);
    },

    resetSList(val) {
      let sortCarretTrigger = this.sList;
      let except = val ? val : '';
      for (let prop in sortCarretTrigger) {
        if (sortCarretTrigger.hasOwnProperty(prop)) {
          sortCarretTrigger[prop] = null;
        } else if (except) {
          if (prop == except) {
            sortCarretTrigger[prop] = sortCarretTrigger[prop];
          }
        }
      }
    },

    reset() {
      this.resetSList();
      this.searchCrew();
    },

    batchNoDtls({id, batch_no}) {
      return `${batch_no}`;
    },

    batchSearch() {
      this.searchCrew(1);
    },

    //todo route for clicabe batch no.
    gotToBatch() {

    },

    endorsed_remarks(id) {
      this.getCrewEndorseRemarks({id: id});
    },

    async cancel_endorsement() {
      console.log('action button for the cancel');
      this.newRemarks.crew_reservation_id = this.reservationId;
      if (await this.questionAlert('Are you sure you want to cancel this endorsement.?')) {
        this.cancelCrewEndorse(this.newRemarks).then((res) => {
          if (res == true) {
            this.setNullNewRemark();
            this.searchCrew(1);
            this.successAlert('Endorse Crew Cancel Successfully.');
          }
        });
      }
    },

    async approve_endorsement() {
      if (await this.questionAlert('Are you sure you want to approve this endorsement.')) {
        let params = {
          selectedEndorseIds: this.selectedEndorseIds,
          actionMessage: this.newRemarks,
        };
        this.approvedCrewEndorse(params).then((res) => {
          if (res == true) {
            this.searchCrew(1);
            this.setNullNewRemark();
            this.selectedEndorseIds = [], //reset checkbox.
            this.successAlert('Successfully Approved');
            $('#actionRemarks').modal('hide');
          }
        });
      }
    },

    async extend_endorsement() {
      this.newRemarks.crew_reservation_id = this.reservationId;
      let params = {
        bookedId: this.bookedId,
        remarks: this.newRemarks,
      };
      if (await this.questionAlert('Request for extend the booked', 'Extend Booked')) {
        this.isExtendBooking(params).then((response) => {
          this.searchCrew(1);
          this.setNullNewRemark();
          this.successAlert('Request Successfully ');
          return true;
        }).catch((error) => {
          GlobalUtility.failProgressBar();
          GlobalUtility.generateResponseMessage(error, 'Reqeust Extend Endorsement');
          return false;
        });
      }
    },

    selectAll: function() {
      this.selectedEndorseIds = [];
      if (!this.allSelected) {
        for (let endorsed in this.crewEndorseList) {
          if (!this.crewEndorseList[endorsed].is_approved && this.crewEndorseList[endorsed].is_active) {
            this.selectedEndorseIds.push(this.crewEndorseList[endorsed].crew_reservation_id);
          }
        }
      }
    },

    select() {
      this.allSelected = false;
    },

    setActionType(object, value) {
      this.reservationId = object ? object.crew_reservation_id : null;
      this.bookedId = object ? object.booked_id : null;
      this.actionType = value;
    },

    crew_endorse_details(id) {
      this.getCrewEndorseDetails({id: id});
    },

    //updateCrewEndorseDetails
    async update_crew_endorsement_dtls() {
      let startDate = Date.parse(this.crewEndorse.endorsed_check_in);
      let endDate = Date.parse(this.crewEndorse.endorsed_check_out);
      if (startDate > endDate) {
        this.warningAlert('The Check-out date must come after the Check-in date');
      } else if (this.newRemarks.remarks == null || this.newRemarks.remarks == '') {
        this.warningAlert('Please input remarks upon updating');
      } else {
        if (await this.questionAlert('Are you sure you want to update this endorsement.')) {
          this.crewEndorse.newRemarks = this.newRemarks;
          this.updateCrewEndorseDetails(this.crewEndorse).then((res) => {
            if (res == true) {
              this.setNullNewRemark();
              this.searchCrew(1);
              this.successAlert('Update Successfully');
            }
          });
        }
      }
    },

    async delete_crew_endorse(id) {
      if (await this.questionAlert('Are you sure you want to remove this')) {
        this.deleteCrewEndorseMentList(id).then((res) => {
          if (res == true) {
            this.successAlert('Record successfully remove');
          }
        });
      }
    },

    disableCheckbox(value) {
      if (!value.is_approved && value.is_active) {
        return false;
      }
      return true;
    },

    bookedExpired(obj) {
      if (obj.is_overStayed && !obj.is_checkOut) {
        return 'isOverstay';
      }
      return '';
    },
  },

  computed: {
    ...mapGetters([
      'crewEndorseList',
      'endorsePagination',
      'batchKeyDetails',
      'hotelKeys',
      'newRemarks',
      'crewEndorse',
      'remarks',
      'endorseMentParams',
    ]),

    paginationPages() {
      let pages = [];
      let currentPage = this.endorsePagination.currentPage;
      let lastPage = this.endorsePagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },
  },

  created() {
    this.searchCrew(this.endorseMentParams.page);
    this.searchBy();
    this.getBatchKeyDetails();
    this.getHotelKeyDetails();
  },

  mounted() {
    $(function() {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
      });
      // $('[data-toggle="hover"]').tooltip();
    });
  },

  destroyed() {
    this.setNullCrewEndorsed();
    this.setNullNewRemark();
  },

  // beforeMount() {
  //   this.searchCrew(1);
  // }

};
</script>

<style scoped>

.table tbody > tr > td.vert-aligned {
  vertical-align: middle;
  padding: 0 !important;
}


u:hover,
u:focus {
  color: #2c82c9 !important;
  color: #4a4f54;
}

input[type=checkbox] {
  transform: scale(1.7);
}

.fs-13px {
  font-size: 13px;
}

/*.btn-view-container {*/
/*  width: 75px;*/
/*  border-right: 0px solid;*/
/*}*/
.btn-req-container {
  width: 125px;
  border-left: 0px solid;
}
</style>

<style scope>

.btn-xsm, .btn-group-xsm > .btn {
  padding: 0.20rem 0.2rem !important;
  font-size: 0.870rem !important;
  line-height: 1 !important;
  border-radius: 0.25rem !important;
}

.multiselect__select {
  position: absolute;
  width: 30px !important;
  height: 39px !important;
  right: 2px !important;
  top: 1px !important;
  padding: 2px 6px !important;
  text-align: center;
  transition: transform .2s ease;
  background-color: #e3e3e3 !important;
}

.multiselect__tags {
  /*padding: 2px 30px !important;*/
  min-height: 10px !important;
  display: block;
  padding: 3px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}

.multiselect__element {
  font-size: 14px !important;
  font-weight: bold !important;
}

</style>
